import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Role } from '../_models/Role';
import { AppConstants } from '../constants/constants';
import { APP_CONFIG } from '../lib/angular/injection-tokens';
import { IAppConfig } from '../lib/config/app-config';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  private baseUrl: string = this.config.protectedResourceEndpoint;
  private static readonly path: string = "Role/";
  private static readonly GETADMINROLES_URI: string = "getadministratorroles";

  constructor(private http: HttpClient, @Inject(APP_CONFIG) private config: IAppConfig) { }

  public getRoles$(): Observable<Role[]> {
    return this.http.get<Role[]>(this.baseUrl + AppConstants.ROLE);
  }

  public getRoleById$(id): Observable<Role> {
    return this.http.get<Role>(this.baseUrl + AppConstants.ROLE + '/' + id);
  }

  public getAdministratorRoles$(): Observable<Role[]> {
    return this.http.get<Role[]>(`${this.baseUrl}${RoleService.path}${RoleService.GETADMINROLES_URI}`);
  }
}
